import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import InfoWithIconsSimple from './InfoWithIconsSimple';
import { sizes } from '../../Typography/constants/sizes';
const InfoWithIcons = ({
  size = 'base',
  ...props
}) => /*#__PURE__*/React.createElement(InfoWithIconsSimple, _extends({
  lineHeight: (sizes[size] || sizes.default).lineHeight
}, props));
export default InfoWithIcons;